import { isNullOrUndefined } from "../better/utils";
import * as cookie from "cookie";
export const SCOPE_COOKIE = "TS_AUTH_SCOPES";
const AUTH = "TS_AUTH";
function getCookieValueParsed(cookieName) {
    const cookieStr = document.cookie;
    const lastCookies = cookie.parse(cookieStr);
    return cookieName in lastCookies ? lastCookies[cookieName] : null;
}
export function authCookieExists() {
    return !!getCookieValueParsed(AUTH);
}
export function scopesFromCookie() {
    const cookieValue = getCookieValueParsed(SCOPE_COOKIE);
    try {
        const cookieScopeRequirements = cookieValue
            ? JSON.parse(window.atob(cookieValue))
            : {};
        return Object.keys(cookieScopeRequirements).map((service) => ({
            service: service,
            scopes: cookieScopeRequirements[service].map((scope) => scope),
        }));
    }
    catch (e) {
        return [];
    }
}
function matchesScopeRequirments(currentScopes, menuScope) {
    if (typeof menuScope !== "string" && "scopeConditions" in menuScope) {
        if (menuScope.scopeConditions === "OR") {
            return currentScopes.some((curScope) => menuScope.scopes.indexOf(curScope) !== -1);
        }
        if (menuScope.scopeConditions === "AND_NOT") {
            return (currentScopes.length >= 1 &&
                currentScopes.some((curScore) => curScore === menuScope.requiredScope) &&
                !currentScopes.some((curScore) => menuScope.absentScopes.indexOf(curScore) !== -1));
        }
        if (menuScope.scopeConditions === "AND") {
            return menuScope.scopes.every((menuScope) => currentScopes.includes(menuScope));
        }
    }
    else {
        return currentScopes.some((curScope) => curScope === menuScope || curScope === "*");
    }
    return false;
}
export function scopeRequirementIsFulfilled(menuScopeRequirement, cookieScopeRequirements) {
    return cookieScopeRequirements.some((cookieScopeRequirement) => cookieScopeRequirement.service === menuScopeRequirement.service &&
        matchesScopeRequirments(cookieScopeRequirement.scopes, menuScopeRequirement.scope));
}
export function menuItemShouldBeShown(scopeRequirement, cookieScopeRequirements) {
    if (isNullOrUndefined(scopeRequirement)) {
        return true;
    }
    return scopeRequirementIsFulfilled(scopeRequirement, cookieScopeRequirements);
}
//# sourceMappingURL=scopesfromcookie.js.map